import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faFileImport } from '@fortawesome/free-solid-svg-icons';
import { useImportarEstoqueControlado } from 'hooks/useSngpc';
import { useBreakpoints } from 'providers/BreakpointsProvider';

interface BotaoImportarEstoqueProps {
    disabled?: boolean;
}

const BotaoImportarEstoque: React.FC<BotaoImportarEstoqueProps> = ({ disabled = false }) => {
    const importarEstoqueMutation = useImportarEstoqueControlado();
    const { breakpoints } = useBreakpoints();
    const isMobile = breakpoints.down('md');

    const handleImportar = async () => {
        try {
            await importarEstoqueMutation.mutateAsync();
        } catch (error) {
            // Erro já tratado no hook
            console.error('Erro ao importar estoque:', error);
        }
    };

    return (
        <Button
            variant="outline-info"
            onClick={handleImportar}
            disabled={disabled || importarEstoqueMutation.isPending}
            className={isMobile ? 'flex-fill' : ''}
        >
            <FontAwesomeIcon
                icon={isMobile ? faFileImport : faDownload}
                className="me-2"
                spin={importarEstoqueMutation.isPending}
            />
            {importarEstoqueMutation.isPending
                ? (isMobile ? 'Importando...' : 'Importando...')
                : (isMobile ? 'Importar' : 'Importar Estoque Atual')
            }
        </Button>
    );
};

export default BotaoImportarEstoque; 